import { render, staticRenderFns } from "./UpdatePhotoDialog.vue?vue&type=template&id=5fb1f234&scoped=true&lang=pug&"
import script from "./UpdatePhotoDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdatePhotoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb1f234",
  null
  
)

export default component.exports